/**
 * @author Raghav Prabhu
 * @desc Login authentication service
 */
import service from '../Common/'
import constants from '../../../settings/shared/constants'

/**
 * This function helps to authenticate with backend and 
 * returns its response.
 * 
 * @param {*} user {email, password, tenant}
 */

function auth(user) {
   let authUrl = "";
   if (process.env.REACT_APP_IS_SUBDOMAIN === "true") {
      authUrl = constants.api.auth.login
   } else {
      authUrl = constants.api.auth.authLogin
      delete user["tenant"]
   }
   return service({
      url: authUrl,
      method: 'POST',
      data: user
   });
}

function auth_tenant(users) {
   let tData = {
      "email": users.email,
      "accountId": users.accountId,
   }
   let headers = { "Authorization": "Bearer " + users.authToken }
   return service({
      url: constants.api.auth.validateAuth,
      method: 'POST',
      headers: headers,
      data: tData
   });
}

function auth_accounts(token) {
   let headers = { "Authorization": "Bearer " + token }
   return service({
      url: constants.api.auth.authAccounts,
      method: 'GET',
      headers: headers,
      data: {}
   });
}

function auth_register(user) {
   //let headers = {'Content-Type':'application/json'}
   return service({
      url: constants.api.auth.register,
      method: 'POST',
      data: user
   });
}

function forgotPassword(data) {
   //let headers = {'Content-Type':'application/json'}
   return service({
      url: constants.api.auth.forgotPass + "?email=" + data.email,
      method: 'POST',
      data: ''
   });
}

function forgotPasswordResetLink(email, token) {
   //let headers = {'Content-Type':'application/json'}
   return service({
      url: constants.api.auth.forgotPassResetlink + "?email=" + email + "&resetToken=" + token,
      method: 'GET',
      data: ''
   });
}

function signupResetLink(email, token) {
   //let headers = {'Content-Type':'application/json'}
   return service({
      url: constants.api.auth.signupVerify + "?email=" + email + "&resetToken=" + token,
      method: 'GET',
      data: ''
   });
}

//To export authentication function
const LoginService = {
   auth, auth_register, forgotPassword, auth_tenant, auth_accounts, forgotPasswordResetLink,
   signupResetLink
}

export default LoginService;
